import axios from 'services/index';
import config from 'config/config';

/**
 * Get the branding details for a brand.
 *
 * Resolves to `null` without issuing a request when no brand is supplied. The
 * API rejects an empty `brand` with a 400, and the previous implementation
 * built an empty URL for that case, which sent the request to the portal's own
 * origin instead of the API.
 *
 * @param {string|null} brand - The brand name to look up
 * @returns {Promise<Object|null>} The axios response, or null when unbranded
 */
async function getBrand(brand = null) {
    const brandName = typeof brand === 'string' ? brand.trim() : '';

    if (!brandName) {
        return null;
    }

    return axios.get(`${config.API_URL}portal/brand?brand=${encodeURIComponent(brandName)}`);
}

export default {
    getBrand
};
